import Moment from 'react-moment'
import { useTranslation } from 'react-i18next'

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col items-center py-[22px] md:flex-row md:justify-center'>
      <img
        alt='logo'
        className='mb-[16px] w-[145px] cursor-pointer md:mb-0 md:mr-[37px]'
        src={'/logo.svg'}
      />
      <p className='text-[14px] text-white/[0.75] md:mt-[17px]'>
        © <Moment format='YYYY'>{new Date()}</Moment> {t('project.name')}.{' '}
        {t('other.allRightsReserved')}.
      </p>
    </div>
  )
}
